// extracted by mini-css-extract-plugin
export default {"QuestionsMenu":"QuestionsMenu_QuestionsMenu__s5Dyu"};